import { getLoadTracking as getLoadTrackingApi } from '@/api/dispatch'
import { getTrackingRouteMatch as getTrackingRouteMatchApi } from '@/api/heremap'

function getTrackingRouteMatchParams(data) {
  return data.reduce((acc,cur)=>acc+=`${cur.lat},${cur.lon}\n`,'LATITUDE,LONGITUDE\n');
}

function getShape(shapes) {
  let positions = []
    for (let i = 0; i < shapes.length; i+=2) {
      positions.push({ lat: shapes[i], lng: shapes[i+1] })
    }
    return positions
}

function getRouteDetails(result) {
  try {
    let route = result.res.data.response.route[0]
    return {
      route: getShape(route.shape),
      waypoint: route.waypoint
    }
  } catch {
    return null
  }
}

const store = {
  namespaced: true,
  state: {
    trackingRequestLoading: false,
    trackingRequestError: false,
    routeMatchRequest: false, // 是否完成routeMatch请求
    trackingInfo: {},
    routeMatchInfo: {},
    activeEvent: null,
    isLoading: false
  },
  mutations: {
    SET_TRACKING_REQUEST_LOADING(state, status) {
      state.trackingRequestLoading = status
    },
    SET_TRACKING_REQUEST_ERROR(state, status) {
      state.trackingRequestError = status
    },
    SET_ROUTE_MATCH_REQUEST(state, status) {
      state.routeMatchRequest = status
    },
    SET_TRACKING_INFO(state, info) {
      state.trackingInfo = Object.assign({}, info.data, {id: info.id})
    },
    SET_ROUTE_MATCH_INFO(state, info) {
      state.routeMatchInfo = info
    },
    SET_ACTIVE_EVENT(state, event) {
      state.activeEvent = event
    },
    SET_IS_LOADING(state, data) {
      state.isLoading = data
    }
  },
  actions: {
    getLoadTracking({ commit, dispatch, state }, loadId) {
        if(!state.isLoading) {
          commit('SET_TRACKING_REQUEST_LOADING', true)
        }else{
          commit('SET_TRACKING_REQUEST_LOADING', false)
        }
        getLoadTrackingApi(loadId).then(res => {
          let data = Object.assign(res.data, {eventLine: res.data.eventLine.map(item => {
            return {
              ...item,
              eventId: item.name
            }
          })})
          console.log(data,'76');
          commit('SET_TRACKING_REQUEST_ERROR', data.eventLine.every(item => item.status === 'unfinished'))
          commit('SET_TRACKING_INFO', {id: loadId, data: data})
          dispatch('getTrackingRouteMatch', res.data.driveRoute)
        }).catch(() => {
          commit('SET_TRACKING_REQUEST_ERROR', true)
        }).finally(() => {
          commit('SET_TRACKING_REQUEST_LOADING', false)
        })
    },
    getTrackingRouteMatch({ commit }, data) {
      if (data && Array.isArray(data)) {
        let requestList = data.map(item => {
          if (item.length > 1) {
            return getTrackingRouteMatchApi(getTrackingRouteMatchParams(item))
          }
          return null
        })
        let routeList = []
        let waypoints = {}
        commit('SET_ROUTE_MATCH_REQUEST', true)
        Promise.all(requestList).then(result => {
          routeList = result.map((item, index) => {
            let res = item === null ? null : getRouteDetails(item)
            let originRoute = data[index]
            if (item === null || res === null) {
              let waypoint = originRoute[0]
              // 与here返回的格式一致
              waypoints[waypoint.id] = {
                mappedPosition: { latitude: waypoint.lat, longitude: waypoint.lon },
                originalPosition: { latitude: waypoint.lat, longitude: waypoint.lon }
              }
              return [{ lat: waypoint.lat, lng: waypoint.lon }]
            } else {
              res.waypoint.map((item, i) => {
                let waypoint = originRoute[i]
                waypoints[waypoint.id] = {
                  mappedPosition: item.mappedPosition,
                  originalPosition: item.originalPosition
                }
              })
              return res.route
            }
          })
          commit('SET_ROUTE_MATCH_INFO', { routeList, waypoints })
        }).catch(() => {
          commit('SET_ROUTE_MATCH_INFO', {})
        })
      } else {
        commit('SET_ROUTE_MATCH_INFO', {})
      }
    },
    getActiveEvent({ commit }, data) {
      commit('SET_ACTIVE_EVENT', data ? Object.assign({}, data) : null)
    },
    getIsLoading({ commit }, data) {
      commit('SET_IS_LOADING', data)
    }
  }
}

export default store